import * as React from 'react';

export interface SidebarTitleItemNextProps {
  dataHook?: string;
  children?: React.ReactNode;
  className?: string;
}

export default class SidebarTitleItemNext extends React.PureComponent<SidebarTitleItemNextProps> {}
